import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Customer Count Cell Renderer
 *
 * Displays the number of customers/business partners for a material.
 * Shows a simple numeric count.
 *
 * @example
 * ```typescript
 * {
 *   colId: 'customerCount',
 *   headerName: 'Cantidad de Clientes',
 *   cellRenderer: CustomerCountCellRendererComponent,
 *   minWidth: 150
 * }
 * ```
 */
@Component({
  selector: 'app-customer-count-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="text-sm">
      {{ count }}
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class CustomerCountCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  get count(): number {
    return this.params.data?.businessPartners?.length || 0;
  }
}
